import axios from 'axios';

export default class psProfileFavorites {
    constructor() {
        this._init();
    }

    _init() {
        const openButton = document.getElementById('profile-favorites');
        const menu = openButton && document.getElementById(openButton.getAttribute('aria-controls'));

        if (!(openButton && menu)) {
            return;
        }

        openButton.addEventListener('click', () => {
            openButton.setAttribute('aria-expanded', true);
            menu.toggleAttribute('hidden', false);
        });

        const closeButton = document.getElementById('profile-favorites-close');
        closeButton && closeButton.addEventListener('click', () => {
            menu.toggleAttribute('hidden', true);
            openButton.setAttribute('aria-expanded', false);
        });

        this._initEdit();
        this._initRemove();
        this._initFavoriteToggle();
    }

    _initEdit() {
        const editFavoritesButton = document.getElementById('edit-favorites');
        editFavoritesButton && editFavoritesButton.addEventListener('click', () => {
            const enabled = editFavoritesButton.classList.toggle('setting-icon--check-icon');
            for (const btn of document.querySelectorAll('#updatedfavorites .favorite-item__remove')) {
                btn.toggleAttribute('hidden', !enabled);
            }
        });
    }

    _initRemove() {
        const container = document.getElementById('updatedfavorites');
        container && container.addEventListener('click', event => {
            if (!event.target.classList.contains('favorite-item__remove')) {
                return;
            }

            event.preventDefault();

            const btn = event.target;
            const loader = document.querySelector('#favorites-section .favorites-ajax-loading');
            loader.toggleAttribute('hidden', false);

            const id = btn.getAttribute('data-id');

            axios.post('/api/ps/profile/favorites/remove', { id })
                .then(() => {
                    document.querySelectorAll('#page-container .profile__favorite-page-toggle')
                        .forEach(btn => btn.classList.remove('added'));

                    const item = btn.closest('.favorite-item');
                    item && item.remove();
                })
                .catch(error => {
                    this._error(error);
                })
                .finally(() => {
                    loader.toggleAttribute('hidden', true);
                });
        });
    }

    _initFavoriteToggle() {
        document.getElementById('main-content').addEventListener('click', event => {
            if (!event.target.classList.contains('profile__favorite-page-toggle')) {
                return;
            }

            const loader = document.getElementById('favorites-section').querySelector('.favorites-ajax-loading');
            loader.toggleAttribute('hidden', false);

            const state = event.target.classList.contains('added');
            const url = "/api/ps/profile/favorites/" + (state ? "remove" : "add");

            const id = event.target.getAttribute('data-id');

            axios.post(url, { id })
                .then(() => {
                    document.querySelectorAll('#page-container .profile__favorite-page-toggle[data-id="' + id + '"]')
                        .forEach(btn => btn.classList.toggle('added', !state));

                    return axios.get('/api/ps/profile/favorites')
                        .then(response => {
                            document.getElementById('updatedfavorites').innerHTML = response.data
                        });
                })
                .catch(error => {
                    this._error(error);
                })
                .finally(() => {
                    loader.toggleAttribute('hidden', true);
                });
        });
    }

    _error(error) {
        const id = error && error.response && error.response.status === 401 ? 'ps-profile-logged-out' : 'ps-profile-generic-error';
        const node = document.getElementById(id);
        node && alert(node.value);
    }
}
